<script setup lang="ts">
import { computed } from 'vue'

import { useAlertConditionText } from '../composables/useAlertConditionText'
import { conditionOptionFor } from '../models/alert.constants'
import type { AlertMetricCondition } from '../models/alert.types'
import { AlertMetricLabel, useAlertCellFormatter } from '../models/reports-bridge'

import { Icon } from '@/shared/ui'

const props = defineProps<{
  condition: AlertMetricCondition | null
  compareDays?: number | null
}>()
const cell = useAlertCellFormatter()
const conditionText = useAlertConditionText()

const option = computed(() => conditionOptionFor(props.condition?.operator))
const parts = computed(() =>
  props.condition ? conditionText.parts(props.condition, props.compareDays) : null,
)
const amount = computed(() => parts.value?.amount ?? cell.formatCell(null, null))
const operator = computed(() => parts.value?.operator ?? '')
const comparison = computed(() => parts.value?.comparison ?? '')
</script>

<template>
  <span
    v-if="condition"
    class="condition-badge inline-flex max-w-full items-center gap-xs text-primary text-[0.75rem]"
  >
    <AlertMetricLabel :column="condition.column" :size="14" />
    <span
      class="condition-badge__expression inline-flex min-w-0 items-center gap-2xs whitespace-nowrap"
    >
      <Icon
        v-if="condition.mode === 'percentage' && option"
        :name="option.trend === 'up' ? 'chevron-up' : 'chevron-down'"
        :size="12"
      />
      <strong>{{ operator }}</strong>
      <span>{{ amount }}</span>
      <small v-if="comparison">{{ comparison }}</small>
    </span>
  </span>
  <span v-else>{{ cell.formatCell(null, null) }}</span>
</template>

<style scoped>
.condition-badge .condition-badge__expression small {
  overflow: hidden;
  color: var(--ui-color-subtle);
  font-size: inherit;
  font-weight: 400;
  text-overflow: ellipsis;
}

.condition-badge__expression small {
  overflow: hidden;
  color: var(--ui-color-subtle);
  font-size: inherit;
  font-weight: 400;
  text-overflow: ellipsis;
}
</style>
